var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3529 0.588135H1.64707C0.738827 0.588135 0 1.32696 0 2.2352V13.7646C0 14.6726 0.738827 15.4117 1.64707 15.4117H18.3529C19.2609 15.4117 20 14.6726 20 13.7646V2.2352C20 1.32696 19.2609 0.588135 18.3529 0.588135ZM18.5882 13.7646C18.5882 13.8921 18.4804 13.9999 18.3529 13.9999H1.64707C1.51953 13.9999 1.41176 13.8921 1.41176 13.7646V4.7093L9.52444 9.47894C9.74279 9.60742 10.0134 9.60905 10.2331 9.48316L18.5882 4.69633V13.7646ZM18.5882 3.0693L9.88705 8.05425L1.41176 3.07141V2.23516C1.41176 2.10762 1.51953 1.99989 1.64707 1.99989H18.3529C18.4805 1.99989 18.5882 2.10766 18.5882 2.23516V3.0693Z",
    fill: "#023047",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.99d9d7f5156afbbc46855c9fb4826d2f.svg";
export { ForwardRef as ReactComponent };